import type { VehicleSearchQueryParam } from '../types';
import { CustomFilterGroups, FilterSummaryGroups } from '../types';

type GroupToQueryParamMap = {
    [groupId in FilterSummaryGroups]: VehicleSearchQueryParam;
} & {
    [CustomFilterGroups.DEALERSHIPS]: VehicleSearchQueryParam;
};

const groupToQueryParamMap: GroupToQueryParamMap = {
    [FilterSummaryGroups.INVENTORY_TYPES]: 'inventoryType',
    [FilterSummaryGroups.YEARS]: 'year',
    [FilterSummaryGroups.MAKES]: 'make',
    [FilterSummaryGroups.MODELS]: 'model',
    [FilterSummaryGroups.TRIMS]: 'trim',
    [FilterSummaryGroups.BODY_STYLES]: 'bodyStyle',
    [FilterSummaryGroups.ENGINES]: 'engine',
    [FilterSummaryGroups.EXTCOLORS]: 'extColor',
    [FilterSummaryGroups.INTCOLORS]: 'intColor',
    [CustomFilterGroups.DEALERSHIPS]: 'commonOrgDealerId'
};

export const getQueryParamByFilterId = (groupId: CustomFilterGroups | FilterSummaryGroups) => {
    return groupToQueryParamMap[groupId as keyof GroupToQueryParamMap];
};
